// Libraries
import 'slick-carousel'
import 'jquery-placeholder'
import 'js-cookie'

// Modules
import KnowledgeSearch from './modules/KnowledgeSearch'
import KnowledgeFilter from './modules/KnowledgeFilter'
import ScrollTop from './modules/ScrollTop'
import SiteTerms from './modules/SiteTerms'
import AlertMessage from './alert-message/AlertMessage'
import MainCallback from './modules/MainCallback'
import Csr from './modules/Csr'

// Products
import Vps from './products/Vps'
import Colo from './products/Colo'
import Vdc from './products/Vdc'
import Rack from './products/Rack'
import Dedic from './products/Dedic'
import DedicNew from './products/DedicNew'
import Cart from './modules/Cart'
import Vacancy from './modules/Vacancy'
import EventsTracking from './modules/EventsTracking'
import VpsBitrix from './products/VpsBitrix'
import Ssl from './products/Ssl'

document.addEventListener('DOMContentLoaded', function (event) {
// Main Callback form
  const mainCallback = new MainCallback()

  const scrollTop = new ScrollTop()
  const siteTerms = new SiteTerms()

  /**
   * Alert for Technical Message
   */
  const alertMessage = new AlertMessage()

  /**
   * KnowledgeBase
   */
  const knowledgeSearch = new KnowledgeSearch()
  const knowledgeFilter = new KnowledgeFilter()

  /**
   * Products
   */
  if (typeof gform !== 'undefined') {
    const vps = new Vps()
    const colo = new Colo()
    const vdc = new Vdc()
    const rack = new Rack()
    const dedic = new Dedic()
    const dedicNew = new DedicNew()
    new VpsBitrix()
  }

  new EventsTracking()
  new Cart()
  new Vacancy()

  new Ssl()

})


